import React, { useEffect } from "react";
import classes from "./AppLayout.module.scss";
import { Outlet, useNavigate } from "react-router-dom";
import LayoutHeader from "./LayoutHeader";
import VersionGate from "../util/VersionGate";
import { Box } from "@mui/material";
import { userState } from "../../states/userState";
import { useRecoilValue } from "recoil";
import { User } from "../../types";
import { zoomState } from "../../states/zoomState";
const layoutHeaderHeight = 56;
const AppLayout = () => {
  const user = useRecoilValue<User>(userState);
  const navigation = useNavigate();
  const zoomLevel = useRecoilValue(zoomState);
  useEffect(() => {
    if (user.isAuth) {
      navigation(user.initialParameters.latestUrl as string);
    }
  }, []);
  return (
    <div className={classes.rootContainer}>
      <LayoutHeader />
      {/* 夜勤2直 brush-up: 旧バンドル検知→最新化(transformの外に置きposition:fixedを正しく効かせる) */}
      <VersionGate />
      <div
        style={{
          transform: `scale(${zoomLevel})`,
          // transformOrigin: "center top", // 中央上部を起点にスケーリング
          transformOrigin: "0 0",
          width: `${100 / Number(zoomLevel)}%`, // 親コンテナの幅を調整
          height: `${100 / Number(zoomLevel)}%`, // 親コンテナの高さを調整
          overflow: "visible", // 見切れ防止
        }}
      >
        <Box
          component="main"
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "start",
            height: `calc(100vh - ${layoutHeaderHeight}px)`,
          }}
        >
          <Outlet />
        </Box>
      </div>
    </div>
  );
};

export default AppLayout;
